import { Avatar, Box, Typography, Card, CardContent, Grid } from '@mui/material';
import LogoutButton from '@/components/LogoutButton';
import useProfile from '@/hooks/useProfileV2';
import theme from '@/styles/theme';
import styles from './Profile.styles';

const ProfilePage = function (): JSX.Element {
  const { profile } = useProfile();

  return (
    <Box data-testid="profile-page">
      <Card variant="outlined" sx={styles.card}>
        <CardContent>
          <Grid container justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center">
              <Avatar
                src={profile.picture}
                alt={`${profile.username} profile`}
                sx={styles.avatar}
                data-testid="profile-picture"
              >
                <Typography variant="h3">{profile.initials}</Typography>
              </Avatar>

              <Box marginLeft={theme.spacing(2)}>
                <Typography variant="h5" fontWeight={600} data-testid="user-name">
                  {profile.username}
                </Typography>
                <Typography variant="subtitle1" data-testid="user-email">
                  {profile.email}
                </Typography>
              </Box>
            </Box>

            <Box marginTop={{ xs: theme.spacing(2) }}>
              <LogoutButton />
            </Box>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProfilePage;
